export default {
    api_path: "https://martech-api.apachedigital.io/"
    // api_path: "https://martech-api-staging.apachedigital.io/"
}


